export const API = '/api'
export const API_HEALTH_CHECK = '/health-check'
export const API_CALCULATE_SSE = '/calculate/sse'
export const API_GET_PARAMETERS = '/parameters'
export const API_GET_VEHICLE = '/vehicle'
export const API_GET_CITIES = '/cities'
export const API_CONTACT = '/contact'

export const ROUTE_ALLIANZ = '/allianz'
export const ROUTE_CSOB = '/csob'
export const ROUTE_GENERALI = '/generali'
export const ROUTE_GENERTEL = '/genertel'
export const ROUTE_KOMUNALNA = '/komunalna'
export const ROUTE_KOOPERATIVA = '/kooperativa'
export const ROUTE_UNION = '/union'
export const ROUTE_UNIQA = '/uniqa'
export const ROUTE_WUSTENROT = '/wustenrot'

export const ROUTE_CONTRACT = '/contract'
export const ROUTE_CONTRACT_ACCEPT = `${ROUTE_CONTRACT}/:uuid/accept`
export const ROUTE_CONTRACT_RECORD = `${ROUTE_CONTRACT}/:uuid/record`
export const ROUTE_DOCUMENT_GET = '/document/:uuid'

export const API_ALLIANZ_CONTRACT = `${ROUTE_ALLIANZ}${ROUTE_CONTRACT}`
export const API_ALLIANZ_CONTRACT_ACCEPT = `${ROUTE_ALLIANZ}${ROUTE_CONTRACT_ACCEPT}`
export const API_ALLIANZ_CONTRACT_RECORD = `${ROUTE_ALLIANZ}${ROUTE_CONTRACT_RECORD}`
export const API_ALLIANZ_DOCUMENT_GET = `${ROUTE_ALLIANZ}${ROUTE_DOCUMENT_GET}`

export const API_CSOB_CONTRACT = `${ROUTE_CSOB}${ROUTE_CONTRACT}`
export const API_CSOB_CONTRACT_ACCEPT = `${ROUTE_CSOB}${ROUTE_CONTRACT_ACCEPT}`
export const API_CSOB_CONTRACT_RECORD = `${ROUTE_CSOB}${ROUTE_CONTRACT_RECORD}`
export const API_CSOB_DOCUMENT_GET = `${ROUTE_CSOB}${ROUTE_DOCUMENT_GET}`

export const API_GENERALI_CONTRACT = `${ROUTE_GENERALI}${ROUTE_CONTRACT}`
export const API_GENERALI_CONTRACT_ACCEPT = `${ROUTE_GENERALI}${ROUTE_CONTRACT_ACCEPT}`
export const API_GENERALI_CONTRACT_RECORD = `${ROUTE_GENERALI}${ROUTE_CONTRACT_RECORD}`
export const API_GENERALI_DOCUMENT_GET = `${ROUTE_GENERALI}${ROUTE_DOCUMENT_GET}`

export const API_GENERTEL_CONTRACT = `${ROUTE_GENERTEL}${ROUTE_CONTRACT}`
export const API_GENERTEL_CONTRACT_ACCEPT = `${ROUTE_GENERTEL}${ROUTE_CONTRACT_ACCEPT}`
export const API_GENERTEL_CONTRACT_RECORD = `${ROUTE_GENERTEL}${ROUTE_CONTRACT_RECORD}`
export const API_GENERTEL_DOCUMENT_GET = `${ROUTE_GENERTEL}${ROUTE_DOCUMENT_GET}`

export const API_KOMUNALNA_CONTRACT = `${ROUTE_KOMUNALNA}${ROUTE_CONTRACT}`
export const API_KOMUNALNA_CONTRACT_ACCEPT = `${ROUTE_KOMUNALNA}${ROUTE_CONTRACT_ACCEPT}`
export const API_KOMUNALNA_CONTRACT_RECORD = `${ROUTE_KOMUNALNA}${ROUTE_CONTRACT_RECORD}`
export const API_KOMUNALNA_DOCUMENT_GET = `${ROUTE_KOMUNALNA}${ROUTE_DOCUMENT_GET}`

export const API_KOOPERATIVA_CONTRACT = `${ROUTE_KOOPERATIVA}${ROUTE_CONTRACT}`
export const API_KOOPERATIVA_CONTRACT_ACCEPT = `${ROUTE_KOOPERATIVA}${ROUTE_CONTRACT_ACCEPT}`
export const API_KOOPERATIVA_CONTRACT_RECORD = `${ROUTE_KOOPERATIVA}${ROUTE_CONTRACT_RECORD}`
export const API_KOOPERATIVA_DOCUMENT_GET = `${ROUTE_KOOPERATIVA}${ROUTE_DOCUMENT_GET}`

export const API_UNION_CONTRACT = `${ROUTE_UNION}${ROUTE_CONTRACT}`
export const API_UNION_CONTRACT_ACCEPT = `${ROUTE_UNION}${ROUTE_CONTRACT_ACCEPT}`
export const API_UNION_CONTRACT_RECORD = `${ROUTE_UNION}${ROUTE_CONTRACT_RECORD}`
export const API_UNION_DOCUMENT_GET = `${ROUTE_UNION}${ROUTE_DOCUMENT_GET}`

export const API_UNIQA_CONTRACT = `${ROUTE_UNIQA}${ROUTE_CONTRACT}`
export const API_UNIQA_CONTRACT_ACCEPT = `${ROUTE_UNIQA}${ROUTE_CONTRACT_ACCEPT}`
export const API_UNIQA_CONTRACT_RECORD = `${ROUTE_UNIQA}${ROUTE_CONTRACT_RECORD}`
export const API_UNIQA_DOCUMENT_GET = `${ROUTE_UNIQA}${ROUTE_DOCUMENT_GET}`

export const API_WUSTENROT_CONTRACT = `${ROUTE_WUSTENROT}${ROUTE_CONTRACT}`
export const API_WUSTENROT_CONTRACT_ACCEPT = `${ROUTE_WUSTENROT}${ROUTE_CONTRACT_ACCEPT}`
export const API_WUSTENROT_CONTRACT_RECORD = `${ROUTE_WUSTENROT}${ROUTE_CONTRACT_RECORD}`
export const API_WUSTENROT_DOCUMENT_GET = `${ROUTE_WUSTENROT}${ROUTE_DOCUMENT_GET}`

export const ROUTE_TERMINATION = '/termination'
export const ROUTE_TERMINATION_POST = ''
export const ROUTE_TERMINATION_GET = '/:uuid'
export const API_TERMINATION = `${ROUTE_TERMINATION}${ROUTE_TERMINATION_POST}`
export const API_TERMINATION_GET = `${ROUTE_TERMINATION}${ROUTE_TERMINATION_GET}`

export const ROUTE_COMPANY = '/company'
export const ROUTE_COMPANY_AUTOCOMPLETE = '/autocomplete'
export const ROUTE_COMPANY_DETAIL = '/detail'
export const API_COMPANY_AUTOCOMPLETE = `${ROUTE_COMPANY}${ROUTE_COMPANY_AUTOCOMPLETE}`
export const API_COMPANY_DETAIL = `${ROUTE_COMPANY}${ROUTE_COMPANY_DETAIL}`

export const API_DOCS = '/api.json'
export const API_SWAGGER = '/docs'
